import React, { useState } from 'react';

const faqs = [
  {
    question: 'What is the specialty of OJT?',
    answer: 'OJT provides practical exposure to real-world job environments and tools.',
  },
  {
    question: 'What is the duration of OJT?',
    answer: 'Typically, the duration ranges from 1 to 6 months depending on the program.',
  },
  {
    question: 'Who is considered eligible for an on-the-job training program?',
    answer: 'Students, fresh graduates, or job seekers with basic qualifications.',
  },
  {
    question: 'What is the benefit of OJT offered by Professional Training Academy?',
    answer: 'It enhances your resume, provides experience, and improves job placement chances.',
  },
];

const OjtFaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className='ojt-faq'>   <section className="py-5 px-3 container">
      <h2 className="text-center mb-5 fw-bold fs-2 text-primary">Frequently Asked Questions</h2>
      <div className="accordion">
        {faqs.map((faq, index) => (
          <div key={index} className="mb-3 bg-white rounded shadow-sm">
            <button
              className="w-100 text-start d-flex justify-content-between align-items-center p-3 fs-5 fw-medium bg-white border-0"
              onClick={() => toggle(index)}
              style={{ outline: 'none' }}
            >
              {faq.question}
              <span className={`ms-2 arrow ${openIndex === index ? 'rotate' : ''}`}>▼</span>
            </button>
            {openIndex === index && (
              <div className="px-3 pb-3 text-dark">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

    
    </section></div>
  
  );
};

export default OjtFaqSection;
